import { render, staticRenderFns } from "./GoogleOneTap.vue?vue&type=template&id=9debe872&scoped=true&"
import script from "./GoogleOneTap.vue?vue&type=script&lang=ts&"
export * from "./GoogleOneTap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9debe872",
  null
  
)

export default component.exports